<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="600px">
        <div class="row">
            <div class="col-12 mb-4" v-if="form.response_message">
                <el-alert :title="form.response_message"
                          :type="form.response_type"
                          :closable="false">
                </el-alert>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-12" style="font-weight: bold; margin-bottom: 8px">Impresiones</div>
                    <div class="col">
                        <x-button-pdf label="A4"
                                      color="btn-info"
                                      @click="clickToPrint('a4')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_80" class="col">
                        <x-button-pdf label="Ticket"
                                      icon="fa-light fa-receipt"
                                      color="btn-info"
                                      @click="clickToPrint('ticket')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_58" class="col">
                        <x-button-pdf label="58mm"
                                      icon="fa-light fa-receipt"
                                      color="btn-info"
                                      @click="clickToPrint('ticket_58')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_50" class="col">
                        <x-button-pdf label="50mm"
                                      icon="fa-light fa-receipt"
                                      color="btn-info"
                                      @click="clickToPrint('ticket_50')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_a5" class="col">
                        <x-button-pdf label="A5"
                                      icon="fa-light fa-print"
                                      color="btn-info"
                                      @click="clickToPrint('a5')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_a5_v" class="col">
                        <x-button-pdf label="A5-V"
                                      icon="fa-light fa-print"
                                      color="btn-info"
                                      @click="clickToPrint('a5_v')"></x-button-pdf>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="font-weight: bold; margin-bottom: 8px">Descargas</div>
                    <div class="col" style="display: flex; justify-content: center">
                        <x-button-pdf label="A4"
                                      color="btn-info"
                                      icon="fa-light fa-download"
                                      @click="clickDownload('a4', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_80" class="col" style="display: flex; justify-content: center">
                        <x-button-pdf label="Ticket"
                                      color="btn-info"
                                      icon="fa-light fa-download"
                                      @click="clickDownload('ticket', 'pdf')"></x-button-pdf>
                    </div>
                </div>
                <div class="row" v-if="configuration && configuration.enable_printing_without_preview">
                    <div class="col-12" style="font-weight: bold; margin-bottom: 8px">Impresiones sin vista previa</div>
                    <div class="col">
                        <x-button-pdf label="A4"
                                      color="btn-warning"
                                      @click="clickPrint_au('a4', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_80" class="col">
                        <x-button-pdf label="Ticket"
                                      color="btn-warning"
                                      icon="fa-light fa-receipt"
                                      @click="clickPrint_au('ticket', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_58" class="col">
                        <x-button-pdf label="58MM"
                                      color="btn-warning"
                                      icon="fa-light fa-receipt"
                                      @click="clickPrint_au('ticket_58', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_50" class="col">
                        <x-button-pdf label="50MM"
                                      color="btn-warning"
                                      icon="fa-light fa-receipt"
                                      @click="clickPrint_au('ticket_50', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_a5" class="col">
                        <x-button-pdf label="A5"
                                      color="btn-warning"
                                      icon="fa-light fa-receipt"
                                      @click="clickPrint_au('a5', 'pdf')"></x-button-pdf>
                    </div>
                </div>
            </div>
            <div class="col-12 mt-4">
                <el-input v-model="form.customer_email">
                    <el-button slot="append"
                               :loading="loading"
                               icon="el-icon-message"
                               @click="clickSendEmail">Enviar
                    </el-button>
                </el-input>
                <small v-if="errors.customer_email"
                       class="form-control-feedback"
                       v-text="errors.customer_email[0]"></small>
            </div>
            <div class="col-12 mt-4">
                <el-input v-model="form.customer_telephone">
                    <template slot="prepend">+51</template>
                    <el-button slot="append"
                               @click="clickSendWhatsapp">Enviar
                        <el-tooltip class="item"
                                    content="Se recomienta tener abierta la sesión de Whatsapp web"
                                    effect="dark"
                                    placement="top-start">
                            <i class="fab fa-whatsapp"></i>
                        </el-tooltip>
                    </el-button>
                </el-input>
                <small v-if="errors.customer_telephone"
                       class="form-control-feedback"
                       v-text="errors.customer_telephone[0]"></small>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
            </div>
        </div>
    </x-modal>
</template>

<script>
import XModal from "../../../components/XModal.vue";
import XButtonCancel from "../../../components/Form/XButtonCancel.vue";
import XButtonSubmit from "../../../components/Form/XButtonSubmit.vue";
import XButtonPdf from "../../../components/XButtonPdf.vue";

export default {
    components: {XButtonPdf, XButtonSubmit, XButtonCancel, XModal},
    props: ['showDialog', 'recordId', 'showClose', 'record', 'resource', 'technicalService'],
    data() {
        return {
            loading: false,
            title: '',
            errors: {},
            form: {},
            configuration: {},
        }
    },
    async created() {
        this.initForm()
        await this.$http.get(`/configurations/record`)
            .then(response => {
                this.configuration = response.data.data
            })
    },
    methods: {
        initForm() {
            this.title = ''
            this.form = {}
            this.errors = {}
        },
        handleOpen() {
            this.initForm()
            this.form = {
                id: this.record.id,
                external_id: this.record.external_id,
                customer_id: this.record.customer_id,
                customer_email: this.record.customer_email,
                customer_telephone: this.record.customer_telephone,
                message_text: this.record.message_text,
                response_message: this.record.response_message,
                response_type: this.record.response_type,
            }
            if (this.resource === 'quotations') {
                this.title = 'Cotización: '
            }
            if (this.resource === 'order_notes') {
                this.title = 'Pedido: '
            }
            if (this.resource === 'sale-notes') {
                this.title = 'Nota de venta: '
            }
            if (this.resource === 'documents') {
                this.title = 'Comprobante: '
            }
            if (this.resource === 'dispatches') {
                this.title = 'Guía de remisión: '
            }
            if (this.resource === 'technical-services') {
                this.title = 'Servicio técnico: '
            }

            this.title += this.record.number_full
        },
        clickClose() {
            this.$emit('update:showDialog', false)
            this.initForm()
        },
        clickToPrint(format) {
            window.open(`/${this.resource}/print/${this.form.external_id}/${format}`, '_blank');
        },
        clickDownload(format, type) {
            window.open(`/${this.resource}/download/${this.form.external_id}/${type}/${format}`, '_blank');
        },
        clickSendEmail() {
            this.loading = true
            this.$http.post(`/${this.resource}/email`, {
                id: this.form.id,
                customer_id: this.form.customer_id,
                customer_email: this.form.customer_email,
            })
                .then(response => {
                    if (response.data.success) {
                        this.$message.success('El correo fue enviado satisfactoriamente')
                    } else {
                        this.$message.error('Error al enviar el correo')
                    }
                })
                .catch(error => {
                    this.$message.error('Error al enviar el correo')
                })
                .then(() => {
                    this.loading = false
                })
        },
        clickSendWhatsapp() {
            if (!this.form.customer_telephone) {
                return this.$message.error('El número es obligatorio')
            }
            window.open(`https://wa.me/51${this.form.customer_telephone}?text=${this.form.message_text}`, '_blank');
        },
        clickPrint_au(format, type) {
            let direccionframe = `/${this.resource}/print/${this.form.external_id}/${format}`;
            let iframe = this._printIframe;
            if (!this._printIframe) {
                iframe = this._printIframe = document.createElement('iframe');
                document.body.appendChild(iframe);
                this.$message.success('Cargando vista previa...');
                iframe.style.display = 'none';
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 1);
                };
            } else {
                this.$message.success('Cargando vista previa...');
            }
            iframe.src = direccionframe;
        },
    }
}
</script>
